import { Component, Host, h, Prop, JSX } from '@stencil/core'
import { trans } from '~/store'
import { ListingProductBadge } from '@rdss/client'

@Component({
    tag: 'zr-badges',
    styleUrl: 'zr-badges.scss',
    shadow: true,
})

/**
 * ZrBadges component.
 */
export class ZrBadges {
    /**
     * Holds all badges.
     */
    @Prop() badges: ListingProductBadge[]

    /**
     * Holds the discount value.
     */
    @Prop() discount = 0

    private hasBestBeforeBadge = false
    private hasBStockBadge = false
    private hasDiscountBadge = false
    private hasSponsorBadge = false

    private bestBeforeBadgeHeading = trans(
        'frontend/listing/product-box.bestBeforeBadge',
        'Kurzes MHD'
    )

    private bStockBadgeHeading = trans(
        'frontend/listing/product-box.bStockArticleBadge',
        'Rückläufer'
    )

    private sponsorBadgeHeading = trans(
        'frontend/listing/product-box.sponsorBadge',
        'Gesponsert'
    )

    /**
     * Component will render.
     */
    componentWillRender() {
        this.hasBestBeforeBadge = this.badges?.find(e => e.id === 'mhdSale') !== undefined
        this.hasBStockBadge = this.badges?.find(e => e.id === 'bStock') !== undefined
        this.hasDiscountBadge = this.badges?.find(e => e.id === 'sale') !== undefined
        this.hasSponsorBadge = this.badges?.find(e => e.id === 'sponsored') !== undefined
    }

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <zr-badge
                    hasSponsorBadge={this.hasSponsorBadge}
                    sponsorBadgeHeading={this.sponsorBadgeHeading}
                />
                <zr-badge
                    hasBestBeforeBadge={this.hasBestBeforeBadge}
                    bestBeforeBadgeHeading={this.bestBeforeBadgeHeading}
                />
                <zr-badge
                    hasBStockBadge={this.hasBStockBadge}
                    bStockBadgeHeading={this.bStockBadgeHeading}
                />
                <zr-badge
                    hasDiscountBadge={this.hasDiscountBadge}
                    discount={this.discount}
                />
            </Host>
        )
    }
}
